module.exports = __webpack_public_path__ + "static/media/clients-mobile.f1664ab4.png";